var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { ListProvider, useList, } from './ListContext.js';
export const List = (_a) => {
    var { children, divider = false, spacing = 'md', direction = 'vertical', className } = _a, rest = __rest(_a, ["children", "divider", "spacing", "direction", "className"]);
    if (!children) {
        return null;
    }
    return (React.createElement("ul", Object.assign({ className: clsx([
            'flex',
            direction === 'vertical' && 'flex-col',
            direction === 'horizontal' && 'flex-row',
        ], direction === 'vertical' && [
            spacing === 'lg' && '-my-4',
            spacing === 'md' && '-my-2.5',
            spacing === 'sm' && '-my-1.5',
            spacing === 'xs' && '-my-1',
        ], direction === 'horizontal' && [
            spacing === 'lg' && '-mx-4',
            spacing === 'md' && '-mx-2.5',
            spacing === 'sm' && '-mx-1.5',
            spacing === 'xs' && '-mx-1',
        ], divider && [
            'divide-line-subdued',
            direction === 'vertical' && 'divide-y',
            direction === 'horizontal' && 'divide-x',
        ], className) }, rest),
        React.createElement(ListProvider, { spacing: spacing, direction: direction }, children)));
};
const ListItem = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    const { spacing, direction } = useList();
    return (React.createElement("li", Object.assign({ className: clsx(direction === 'vertical' && [
            spacing === 'lg' && 'py-4',
            spacing === 'md' && 'py-2.5',
            spacing === 'sm' && 'py-1.5',
            spacing === 'xs' && 'py-1',
            spacing === 'none' && 'py-0',
            className,
        ], direction === 'horizontal' && [
            'flex-1',
            spacing === 'lg' && 'px-4',
            spacing === 'md' && 'px-2.5',
            spacing === 'sm' && 'px-1.5',
            spacing === 'xs' && 'px-1',
            spacing === 'none' && 'px-0',
            className,
        ], 'empty:hidden') }, rest), children));
};
List.Item = ListItem;
//# sourceMappingURL=List.js.map